import PropTypes from 'prop-types';
import { themeGet } from '@styled-system/theme-get';
import styled from '@emotion/styled';
import { Flex, Text } from '@qga/roo-ui/components';

import { toDisplayDateFormat } from 'lib/utils';
import SummaryItem from '../SummaryItem';
import Label from '../Label';

const NoWrapText = styled(Text)`
  white-space: nowrap;
`;

const FormattedDate = ({ date }) => (
  <NoWrapText as="div" fontSize={['base', 'lg']} lineHeight="tight" mb={0}>
    {toDisplayDateFormat(date)}
  </NoWrapText>
);

const DashWrap = styled(Text)`
  visibility: visible;

  ${themeGet('mediaQueries.0')} {
    visibility: hidden;
  }
`;

const Dash = () => (
  <DashWrap fontSize="base" lineHeight="tight" mx="1">
    &mdash;
  </DashWrap>
);

const StayDates = ({ checkIn, checkOut }) => (
  <SummaryItem icon="dateRange">
    <Flex flexDirection={['row', 'column']}>
      <Label>Check-in</Label>
      <FormattedDate date={checkIn} />
      <Dash />
      <Label>Check-out</Label>
      <FormattedDate date={checkOut} />
    </Flex>
  </SummaryItem>
);

StayDates.propTypes = {
  checkIn: PropTypes.string.isRequired,
  checkOut: PropTypes.string.isRequired,
};

export default StayDates;
